import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { combineReducers, StoreModule } from '@ngrx/store';

import { reviewEffects } from './reviews.entity';
import {
  reviewEntityReducers,
  reviewsEntitySelectorKey,
} from './reviews.entity.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      reviewsEntitySelectorKey,
      combineReducers(reviewEntityReducers)
    ),
    EffectsModule.forFeature(reviewEffects),
  ],
})
export class ReviewsEntityModule {}
